<template>
    <div class="ml10 mr10 mt10 mb20">
        <div class="myContentBox">
            <ul class="billList">
                <li v-for="(item,index) in list" :key="index">
                    <div class="ml10 mr10">
                        <div class="flexBox flexBetween pt5 pb5 billBorder">
                            <div class="flexBox-cell-75">
                                <p class="f8 lh18">{{item.status_text}}</p>
                                <p class="f8 lh18 color_999">{{item.create_time_text}}</p>
                            </div>
                            <div class="flexBox-cell-25 tr">
                                <p class="f10 lh36"
                                   :class="{'color_red':styleName === 'main','color_yellow':styleName === 'main_b','color_green':styleName === 'main_c'}">￥{{item.amount}}</p>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            styleName: {
                type: String,
                default: 'main'
            },
            list: {
                type: Array
            }
        }
    }
</script>
